import { PrefixData } from './model';

export const countryPhones: Array<PrefixData> = [
    { prefix: '+47', flag: 'norway', name: 'Norway' },
    { prefix: '+30', flag: 'greece', name: 'Greece' },
    { prefix: '+263', flag: 'zimbabwe', name: 'Zimbabwe' },
    { prefix: '+260', flag: 'zambia', name: 'Zambia' },
    { prefix: '+967', flag: 'yemen', name: 'Yemen' },
    { prefix: '+681', flag: 'wallis-and-futuna', name: 'Wallis and Futuna' },
    { prefix: '+284', flag: 'virgin-islands-us', name: 'Virgin Islands (US)' },
    { prefix: '+84', flag: 'vietnam', name: 'Vietnam' },
    { prefix: '+58', flag: 'venezuela', name: 'Venezuela' },
    { prefix: '+678', flag: 'vanuatu', name: 'Vanuatu' },
    { prefix: '+998', flag: 'uzbekistan', name: 'Uzbekistan' },
    { prefix: '+598', flag: 'uruguay', name: 'Uruguay' },
    { prefix: '+1', flag: 'united-states', name: 'United States' },
    { prefix: '+44', flag: 'united-kingdom', name: 'United Kingdom' },
    { prefix: '+971', flag: 'united-arab-emirates', name: 'United Arab Emirates' },
    { prefix: '+380', flag: 'ukraine', name: 'Ukraine' },
    { prefix: '+256', flag: 'uganda', name: 'Uganda' },
    { prefix: '+688', flag: 'tuvalu', name: 'Tuvalu' },
    { prefix: '+649', flag: 'turks-and-caicos-islands', name: 'Turks and Caicos Islands' },
    { prefix: '+993', flag: 'turkmenistan', name: 'Turkmenistan' },
    { prefix: '+90', flag: 'turkey', name: 'Turkey' },
    { prefix: '+216', flag: 'tunisia', name: 'Tunisia' },
    { prefix: '+868', flag: 'trinidad-and-tobago', name: 'Trinidad and Tobago' },
    { prefix: '+676', flag: 'tonga', name: 'Tonga' },
    { prefix: '+228', flag: 'togo', name: 'Togo' },
    { prefix: '+670', flag: 'timor-leste', name: 'Timor-Leste' },
    { prefix: '+220', flag: 'gambia', name: 'Gambia' },
    { prefix: '+66', flag: 'thailand', name: 'Thailand' },
    { prefix: '+255', flag: 'tanzania', name: 'Tanzania' },
    { prefix: '+992', flag: 'tajikistan', name: 'Tajikistan' },
    { prefix: '+886', flag: 'taiwan', name: 'Taiwan' },
    { prefix: '+963', flag: 'syria', name: 'Syria' },
    { prefix: '+41', flag: 'switzerland', name: 'Switzerland' },
    { prefix: '+46', flag: 'sweden', name: 'Sweden' },
    { prefix: '+268', flag: 'eswatini', name: 'Eswatini' },
    { prefix: '+597', flag: 'suriname', name: 'Suriname' },
    { prefix: '+249', flag: 'sudan', name: 'Sudan' },
    { prefix: '+94', flag: 'sri-lanka', name: 'Sri Lanka' },
    { prefix: '+34', flag: 'spain', name: 'Spain' },
    { prefix: '+82', flag: 'south-korea', name: 'South Korea' },
    { prefix: '+27', flag: 'south-africa', name: 'South Africa' },
    { prefix: '+252', flag: 'somalia', name: 'Somalia' },
    { prefix: '+677', flag: 'solomon-islands', name: 'Solomon Islands' },
    { prefix: '+386', flag: 'slovenia', name: 'Slovenia' },
    { prefix: '+421', flag: 'slovakia', name: 'Slovakia' },
    { prefix: '+65', flag: 'singapore', name: 'Singapore' },
    { prefix: '+232', flag: 'sierra-leone', name: 'Sierra Leone' },
    { prefix: '+248', flag: 'seychelles', name: 'Seychelles' },
    { prefix: '+381', flag: 'serbia', name: 'Serbia' },
    { prefix: '+221', flag: 'senegal', name: 'Senegal' },
    { prefix: '+996', flag: 'saudi-arabia', name: 'Saudi Arabia' },
    { prefix: '+239', flag: 'sao-tome-and-principe', name: 'São Tomé and Príncipe' },
    { prefix: '+378', flag: 'san-marino', name: 'San Marino' },
    { prefix: '+685', flag: 'samoa', name: 'Samoa' },
    {
        prefix: '+784',
        flag: 'saint-vincent-and-the-grenadines',
        name: 'Saint Vincent and the Grenadines',
    },
    { prefix: '+508', flag: 'saint-pierre-and-miquelon', name: 'Saint Pierre and Miquelon' },
    { prefix: '+758', flag: 'saint-lucia', name: 'Saint Lucia' },
    { prefix: '+869', flag: 'saint-kitts-and-nevis', name: 'Saint Kitts and Nevis' },
    { prefix: '+290', flag: 'saint-helena', name: 'Saint Helena' },
    { prefix: '+250', flag: 'rwanda', name: 'Rwanda' },
    { prefix: '+7', flag: 'russia', name: 'Russia' },
    { prefix: '+40', flag: 'romania', name: 'Romania' },
    { prefix: '+242', flag: 'republic-of-the-congo', name: 'Republic of the Congo' },
    { prefix: '+974', flag: 'qatar', name: 'Qatar' },
    { prefix: '+351', flag: 'portugal', name: 'Portugal' },
    { prefix: '+48', flag: 'poland', name: 'Poland' },
    { prefix: '+63', flag: 'philippines', name: 'Philippines' },
    { prefix: '+51', flag: 'peru', name: 'Peru' },
    { prefix: '+595', flag: 'paraguay', name: 'Paraguay' },
    { prefix: '+675', flag: 'papua-new-guinea', name: 'Papua New Guinea' },
    { prefix: '+507', flag: 'panama', name: 'Panama' },
    { prefix: '+970', flag: 'palestine', name: 'Palestine' },
];
